/**
 * Script: main_shop_2DD-info-modals.js
 * Component: Information Modal Cards
 * Description: Handles opening/closing modal cards and disabling scroll
 */

// Function to disable scrolling on the main page and show overlay
function disableScroll() {
  document.body.style.overflow = 'hidden';
  document.getElementById('modalOverlay').style.display = 'block';
}

// Function to enable scrolling on the main page and hide overlay
function enableScroll() {
  document.body.style.overflow = '';
  document.getElementById('modalOverlay').style.display = 'none';
}

// Event listeners to open the Information Cards
document.querySelectorAll('.highlight-link-2').forEach(link => {
  link.addEventListener('click', function (event) {
    event.preventDefault();
    const targetId = this.getAttribute('data-target');
    document.getElementById(targetId).style.display = 'block';
    disableScroll();
  });
});

// Event listeners to close the Information Cards
document.querySelectorAll('.close-button-1, .close-button-2, .close-button-3, .close-button-4').forEach(button => {
  button.addEventListener('click', function () {
    this.closest('.info-card-1, .info-card-2, .info-card-3, .info-card-4').style.display = 'none';
    enableScroll();
  });
});

// Alternative event handler for info card display (duplicate functionality)
document.querySelectorAll('.highlight-link-2').forEach(link => {
  link.addEventListener('click', function (e) {
    e.preventDefault();
    var target = this.getAttribute('data-target');
    document.getElementById(target).style.display = 'block';
  });
});

document.querySelectorAll('.close-button-1, .close-button-2, .close-button-3, .close-button-4').forEach(button => {
  button.addEventListener('click', function () {
    this.closest('.info-card-1, .info-card-2, .info-card-3, .info-card-4').style.display = 'none';
  });
});
